export const SDK_VERSION = '7.17.0';
